import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "scroll-hint",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  key: 0,
  class: "section knob-color-section"
}
const _hoisted_3 = { class: "section" }
const _hoisted_4 = { class: "section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MaterialSelector = _resolveComponent("MaterialSelector")!
  const _component_LEDSelector = _resolveComponent("LEDSelector")!
  const _component_CheckoutButton = _resolveComponent("CheckoutButton")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "configuratorEl",
    class: "configurator",
    onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleConfiguratorScroll && _ctx.handleConfiguratorScroll(...args)))
  }, [
    _createVNode(_Transition, { name: "scrollhint-fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_1, _cache[1] || (_cache[1] = [
          _createElementVNode("svg", {
            class: "scroll-hint-icon",
            viewBox: "0 0 32 20",
            focusable: "false"
          }, [
            _createElementVNode("path", { d: "M3 3 L16 10 L29 3" })
          ], -1)
        ]), 512), [
          [_vShow, _ctx.showScrollHint]
        ])
      ]),
      _: 1
    }),
    (_ctx.currentKnobType)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "section-title" }, "KNOB COLOR", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "header-divider" }, null, -1)),
          _createVNode(_component_MaterialSelector, {
            "current-material": _ctx.currentMaterial,
            "available-materials": _ctx.availableMaterials,
            "selected-knob-type-name": _ctx.selectedKnobTypeName,
            "is-loading": _ctx.isLoading,
            onMaterialChanged: _ctx.handleMaterialChange
          }, null, 8, ["current-material", "available-materials", "selected-knob-type-name", "is-loading", "onMaterialChanged"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_LEDSelector, {
        "current-l-e-d": _ctx.currentLEDMaterial,
        "is-loading": _ctx.isLoading,
        onLedChanged: _ctx.handleLEDChange
      }, null, 8, ["current-l-e-d", "is-loading", "onLedChanged"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_CheckoutButton, {
        "configuration-data": _ctx.currentConfiguration,
        "is-loading": _ctx.isLoading,
        "product-id": "custom-pedal-configurator"
      }, null, 8, ["configuration-data", "is-loading"])
    ])
  ], 544))
}